import AREAS from './areas'
import CATEGORIA from './categoria'
import PRIORIDAD from './prioridad'

export class RegistroCuipNotification {
  #notification

  constructor(notification) {
    this.#notification = notification
  }

  create(args) {
    const notification = new this.#notification()
    notification.responsable = args.responsable
    notification.afectado = args.afectado
    notification.titulo = AREAS.REGISTRO_PERSONAL + ': Asignación de Cuip'
    notification.mensaje = `Al personal de nuevo ingreso ${args.nombrePersonal} se le ha asignado el CUIP: ${args.cuip}.`
    notification.prioridad = PRIORIDAD.MEDIA
    notification.categoria = CATEGORIA.INFORMATIVA

    return notification
  }
}
